// @flow

import styled from '@emotion/styled'
import * as React from 'react'

import { colors, media } from '@toggl/style'

import * as text from '../text'

type Props = {|
  image: React.Node,
  title: string,
  paragraph: string | React.Node,
|}

export function Integration({ image, title, paragraph }: Props) {
  return (
    <Root>
      <ImageWrapper>{image}</ImageWrapper>
      <TextSection>
        <text.H4 color={colors.pink}>{title}</text.H4>
        <Paragraph>{paragraph}</Paragraph>
      </TextSection>
    </Root>
  )
}

export const Integrations: React.ComponentType<any> = styled.div`
  padding-top: 60px;

  ${media.mq[1]} {
    display: flex;
    flex-wrap: wrap;
  }
`
export const IntegrationsWrapper: React.ComponentType<any> = styled.div`
  h1,
  h2,
  h3,
  h4,
  h5 {
    color: ${(p) => p.theme.primary};
  }

  > h1,
  > h2,
  > h3,
  > h4,
  > h5 {
    text-align: center;
    ${media.mq[1]} {
      margin-bottom: 15px;
    }
  }
`

const ImageWrapper = styled.div`
  text-align: center;

  img {
    width: 100%;
    height: auto;
  }
`

const Paragraph = styled.div`
  margin-top: 8px;
  p {
    ${text.paragraph3};
  }
`

const TextSection = styled.div`
  color: ${colors.beige};
  margin: 20px 0 30px;
  padding-bottom: 25px;
`

const Root: React.ComponentType<any> = styled.div`
  display: flex;
  flex-direction: column;

  ${media.mq[1]} {
    max-width: 600px;
    flex: 55%;
    margin-top: 20px;
    &:nth-of-type(2n) {
      margin-left: auto;
    }
  }
`
